"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenClass = exports.screenClasses = void 0;
var react_1 = require("react");
var config_1 = require("./config");
var getViewPort = function (source) {
    if (source && source.current && source.current.clientWidth) {
        return source.current.clientWidth;
    }
    if (typeof window !== 'undefined' && window.innerWidth) {
        return window.innerWidth;
    }
    return null;
};
exports.screenClasses = ['xs', 'sm', 'md', 'lg', 'xl'];
var useScreenClass = function (source, fallbackScreenClass) {
    var getScreenClass = function () {
        var _a = (0, config_1.getConfiguration)(), breakpoints = _a.breakpoints, defaultScreenClass = _a.defaultScreenClass, maxScreenClass = _a.maxScreenClass;
        var newScreenClass = defaultScreenClass;
        var viewport = getViewPort(source);
        if (viewport) {
            newScreenClass = 'xs';
            if (breakpoints[0] && viewport >= breakpoints[0])
                newScreenClass = 'sm';
            if (breakpoints[1] && viewport >= breakpoints[1])
                newScreenClass = 'md';
            if (breakpoints[2] && viewport >= breakpoints[2])
                newScreenClass = 'lg';
            if (breakpoints[3] && viewport >= breakpoints[3])
                newScreenClass = 'xl';
            // if (breakpoints[4] && viewport >= breakpoints[4]) newScreenClass = 'xxl';
        }
        else if (fallbackScreenClass) {
            newScreenClass = fallbackScreenClass;
        }
        var newScreenClassIndex = exports.screenClasses.indexOf(newScreenClass);
        var maxScreenClassIndex = exports.screenClasses.indexOf(maxScreenClass);
        if (maxScreenClassIndex >= 0 && newScreenClassIndex > maxScreenClassIndex) {
            newScreenClass = exports.screenClasses[maxScreenClassIndex];
        }
        return newScreenClass;
    };
    var _a = __read((0, react_1.useState)(function () { return getScreenClass(); }), 2), screenClass = _a[0], setScreenClass = _a[1];
    (0, react_1.useEffect)(function () {
        var handleWindowResized = function () { return setScreenClass(getScreenClass()); };
        window.addEventListener('resize', handleWindowResized, false);
        return function () {
            window.removeEventListener('resize', handleWindowResized, false);
        };
    }, []);
    return screenClass;
};
exports.useScreenClass = useScreenClass;
//# sourceMappingURL=utils.js.map